import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPagina from '../../actions/reserva/alterarRegistrosPorPaginaReservaBpe'
import determinarPaginaAtual from '../../actions/reserva/determinarPaginaAtualReservaBpe'

export class PaginacaoReservasBpe extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualReservaBpe,
    total: state.reservasBpe.reservasBpe.total,
    registrosPorPagina: state.registrosPorPaginaReservaBpe
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoReservasBpe)
